
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/student/faculty",
      function () {
        return require("private-next-pages/student/faculty/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/student/faculty"])
      });
    }
  